import UploadFile from './src/main'

export default UploadFile



// WEBPACK FOOTER //
// ./src/views/question-review/components/UploadFile/index.js